import { ReactComponent as ChevronIcon } from "../../../../assets/icons/chevron.svg";

export const DropdownIndicator = () => {
    return <ChevronIcon width={14} height={14} />;
};
